import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressSearchComponent } from './address-search/address-search.component';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { GridModule } from '@progress/kendo-angular-grid';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatCardModule } from '@angular/material';
import { SharedRoutingModule } from './shared.routing.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NotificationsComponent } from './notifications/notifications.component';
import { ToastrModule } from 'ngx-toastr';
import { UploaddocumentComponent } from './uploaddocument/uploaddocument.component';
import { NyTableComponent } from './ny-table/ny-table.component';
import { BuildingBadgeComponent } from './building-badge/building-badge.component';
import { SharedMaterialModule } from '../shared-materialdesign/shared-material.module';
import { ReasonForUpdateComponent } from './reason-for-update/reason-for-update.component';
import { FilterPermanetExemptPipe } from './reg-apt-info/filter-permanetExempt.pipe';
import { FilterStatusPipe } from '../shared/reg-apt-info/filter-status.pipe';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { CustomMaxDirective } from './../validators/custom-max-validator.directive';
import { CustomMinDirective } from './../validators/Custom-Min-Validator.directive';
import { CustomNonNegativeDirective } from '../validators/custom-non-negative-validator.directive';
import { WholeNumberDirective } from './directives/whole-number.directive';
import { CurrencyFormatDirective } from './directives/currency.directive';
import { IRUploaddocumentComponent } from './ir-upload-document/ir-upload-document.component';
import { IRUploadedDocumentComponent } from '../shared/ir-uploaded-documents/ir-uploaded-documents.component';
import { NotifyUserComponent } from '../shared/notify-user/notify-user.component';
import { FliterStabilizedEtpaPipe } from './reg-apt-info/fliter-stabilized-etpa.pipe';

import { NgxDropzoneModule } from 'ngx-dropzone';
import { EmailDirective } from './directives/email.directive';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { NgArcProgressComponent } from './ngarc-progress/ngarc-progress.component';
import { AlphabetOnlyDirective } from '../validators/alphabet-only-directive';
import { ScrollTopComponent } from './scroll-top-navigate/scroll-top.component';
import { UploadWrapperComponent } from './upload-wrapper/upload-wrapper.component';
import { FileUploadFieldComponent } from './file-upload-field/file-upload-field.component';
import { BackNextNavigatorComponent } from './back-next-navigator/back-next-navigator.component';
import { BannerLayoutComponent } from './banner-layout/banner-layout.component';
import { MailingAddressAutocompleteComponent } from './mailing-address-autocomplete/mailing-address-autocomplete.component';
import { AdvancedSearchComponent } from './building-search/advanced-search/advanced-search.component';
import { BuildingSearchComponent } from './building-search/building-search.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    declarations: [
        AddressSearchComponent,
        NotificationsComponent,
        UploaddocumentComponent,
        NyTableComponent,
        BuildingBadgeComponent,
        ReasonForUpdateComponent,
        FilterPermanetExemptPipe,
        FilterStatusPipe,
        ConfirmationDialogComponent,
        IRUploaddocumentComponent,
        IRUploadedDocumentComponent,
        NotifyUserComponent,
        NgArcProgressComponent,
        CustomMinDirective,
        CustomMaxDirective,
        AlphabetOnlyDirective,
        CustomNonNegativeDirective,
        WholeNumberDirective,
        CurrencyFormatDirective,
        EmailDirective,
        PhoneMaskDirective,
        FliterStabilizedEtpaPipe,
        ScrollTopComponent,
        FileUploadFieldComponent,
        UploadWrapperComponent,
        BackNextNavigatorComponent,
        BannerLayoutComponent,
        MailingAddressAutocompleteComponent,
        AdvancedSearchComponent,
        BuildingSearchComponent
    ],
    imports: [
        CommonModule,
        SharedRoutingModule,
        UploadModule,
        HttpClientModule,
        MatSelectModule,
        MatFormFieldModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        SharedMaterialModule,
        MatAutocompleteModule,
        InputsModule,
        DropDownsModule,
        MatInputModule,
        ToastrModule.forRoot(),
        GridModule,
        NgxDropzoneModule,
        NgbModule
    ],
    exports: [
        NotificationsComponent,
        AddressSearchComponent,
        UploaddocumentComponent,
        NyTableComponent,
        BuildingBadgeComponent,
        ReasonForUpdateComponent,
        ConfirmationDialogComponent,
        IRUploaddocumentComponent,
        IRUploadedDocumentComponent,
        NotifyUserComponent,
        NgArcProgressComponent,
        MatSelectModule,
        MatFormFieldModule,
        MatCardModule,
        FilterPermanetExemptPipe,
        CustomMinDirective,
        CustomMaxDirective,
        AlphabetOnlyDirective,
        WholeNumberDirective, CurrencyFormatDirective,
        EmailDirective, PhoneMaskDirective,
        FliterStabilizedEtpaPipe,
        FilterStatusPipe,
        ScrollTopComponent,
        NgxDropzoneModule,
        FileUploadFieldComponent,
        UploadWrapperComponent,
        BackNextNavigatorComponent,
        BannerLayoutComponent,
        MailingAddressAutocompleteComponent,
        AdvancedSearchComponent,
        BuildingSearchComponent
    ],
    entryComponents: [
        ConfirmationDialogComponent,
        NotifyUserComponent
    ]

})
export class SharedModule {
}
